import { Auth } from "../Auth/Auth.js";
const auth = new Auth();
window.auth = auth;

import { Profile } from "../Profile/Profile.js";
const profile = new Profile();
window.profile = profile;

import { Catalog } from "../Catalog/Catalog.js";
const catalog = new Catalog();
window.catalog = catalog;

catalog.applyEvents();

// Resize
$(window).resize(function () {
	setTypeDevice();

	if (winnersNav.length) {
		scrollToActiveWinnersNav();
	};

	// SNOW
	// reRenderSnow();
});

// Document clicks
$(document).click(function (e) {
	if (!(window.matchMedia("(min-width: 1024px)").matches) && $(".main-nav__menu").is(":visible")) {
		var callbackPopup = $(".main-nav__menu, .main-nav__toggler");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".main-nav__toggler").removeClass("active");
			$(".main-nav__menu").fadeOut();
		};
	}
});

// Type of device
function isTouchDevice() {
	return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
}

function setTypeDevice() {
	if (isTouchDevice()) {
		$('body').removeClass('des');
		$('body').addClass('mob');
	} else {
		$('body').removeClass('mob');
		$('body').addClass('des');
	}
}
setTypeDevice();

// Scroll
window.addEventListener("scroll", function () {
	if ($(".header").length) {
		if ($(this).scrollTop() > 0 && ($(".header").offset().top - $(this).scrollTop()) <= 0) {
			$(".header").addClass("scrolled");
		} else {
			$(".header").removeClass("scrolled");
		}
	}

	// to top btn
	if ($(this).scrollTop() > 800) {
		$('.to-top').fadeIn();
	} else {
		$('.to-top').fadeOut();
	}
})

$('.to-top').click(function () {
	$('html, body').animate({ scrollTop: 0 }, 1200);
});

// Burger
$(".main-nav__toggler").click(function () {
	$(this).toggleClass("active");
	$(".main-nav__menu").fadeToggle();
});

// user profile popup
$('.mob .user-profile__link--auth').click(function (e) {
	e.preventDefault();
	$('.user-profile__popup').fadeToggle();
});

// Swipers
var swiperBanners = new Swiper('.banners__wrapper', {
	slidesPerView: 1,
	loop: true,
	autoplay: {
		delay: 6000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	watchOverflow: true,
	effect: 'fade',
	fadeEffect: {
		crossFade: true
	},
	navigation: {
		nextEl: '.banners__nav--next',
		prevEl: '.banners__nav--prev'
	},
	pagination: {
		el: '.swiper-pagination',
		clickable: true
	}
});

function StopScan(dontShowWellcome = false) {

	if (html5QrCode != undefined) {

		html5QrCode.stop().then(ignore => {
			// QR Code scanning is stopped.
			console.log("QR Code scanning stopped.");
		}).catch(err => {
			// Stop failed, handle it.
			console.log("Unable to stop scanning.");
		});
	}

	$("#btn-scan-close").hide();
	$("#div-scan").hide();

	if (!dontShowWellcome) {
		$(".bill__tab-content--scan").fadeIn();
	}
}

// Tabs
$(".tabs__tab:not(:first-of-type)").hide();
$(".tabs__nav-item:first-of-type .tabs__nav-btn").addClass("active");
$(".tabs__nav-btn").click(function () {
	if (!$(this).hasClass('active')) {
		$(this).parent(".tabs__nav-item").siblings().children(".tabs__nav-btn").removeClass("active");
		$(this).addClass("active");
		$(this).parents(".tabs").find(".tabs__tab").hide();
		$(".tabs__tab").eq($(this).index(".tabs__nav-btn")).fadeIn();

		StopScan();

	}
});

// Password view toggler
$(".form__password-toggler").click(function (e) {
	$(this).toggleClass("active");
	$(this).siblings(".form__input--password").focus();
	if ($(this).siblings(".form__input--password").attr('type') == 'password') {
		$(this).siblings(".form__input--password").attr('type', 'text');
	} else {
		$(this).siblings(".form__input--password").attr('type', 'password');
	}
});

// Popup
$(".popup__close, .popup__btn-close").click(function (e) {
	$("body").removeClass("no-scroll");
	$(this).closest(".popup").removeClass("active");
});

$(".popup").click(function (e) {
	var callbackPopup = $(".popup__container, .popup-rules")
	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
		$(this).removeClass("active");
		$("body").removeClass("no-scroll");
	};
});

$(".goods-page__activate").click(function (e) {
	$("body").addClass("no-scroll");
	$(".popup-buy").addClass("active");
});

$(".popup-buy__activate").click(function (e) {
	let itemId = $('.goods-page').attr('data-id');
	catalog.buy(itemId);
});

$(".scan-client__admin-auth").click(function (e) {
	$("body").addClass("no-scroll");
	$(".popup-admin-auth").addClass("active");
});

profile.applyEvents();

$(".gifts-operations__item-code").click(function (e) {
	e.preventDefault();

	var $tmp = $("<textarea>");
	$("body").append($tmp);
	$tmp.val($(this).children("span").text()).select();
	document.execCommand("copy");
	$tmp.remove();

	$(this).children(".gifts-operations__item-copied").fadeIn(200).delay(1000).fadeOut(200);
});

$(".bill__to-hand-btn, .bill__results-to-hand").click(function (e) {
	$(".bill__general").hide();
	$(".bill__hand").fadeIn();

	StopScan();
});

$(".bill__to-general").click(function (e) {
	$(".bill__hand").hide();
	$(".bill__general").fadeIn();
});

// Profile nav
var profileNav = $(".profile-page__nav");
function scrollToActiveProfileNav() {
	var profileNavList = $(".profile-page__nav-list");
	var profileNavItemActive = $(".profile-page__nav-link.active");

	profileNavList.scrollLeft(profileNavItemActive.offset().left + profileNavItemActive.outerWidth(true) / 2 + profileNavList.scrollLeft() - profileNavList.outerWidth() / 2);
};

if (!(window.matchMedia("(min-width: 768px)").matches) && profileNav.length) {
	scrollToActiveProfileNav();
};

// Winners nav
var winnersNav = $(".lottery-winners__nav");
function scrollToActiveWinnersNav() {
	var winnersNavList = $(".lottery-winners__nav-list");
	var winnersNavItemActive = $(".lottery-winners__nav-btn.active");

	winnersNavList.scrollLeft(winnersNavItemActive.offset().left + winnersNavItemActive.outerWidth(true) / 2 + winnersNavList.scrollLeft() - winnersNavList.outerWidth() / 2);
};

if (winnersNav.length) {
	scrollToActiveWinnersNav();
};

$(".lottery-winners__nav-btn").click(function (e) {
	scrollToActiveWinnersNav();
});

//------------------------------------------------------------

var table = null;
var scanText = "";
var html5QrcodeScanner = null;
var html5QrCode = null;
var cameraId = "";
var cameraIndex = 0;
var camerasList = [];
var sDebug = "";

//----------------------------------------------

// возвращает куки с указанным name,
// или undefined, если ничего не найдено
function getCookie(name) {
	let matches = document.cookie.match(new RegExp(
		"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
	));
	return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(name, value, options = {}) {

	options = {
		path: '/',
		// при необходимости добавьте другие значения по умолчанию
		//...options
	};

	if (options.expires instanceof Date) {
		options.expires = options.expires.toUTCString();
	}

	let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

	for (let optionKey in options) {
		updatedCookie += "; " + optionKey;
		let optionValue = options[optionKey];
		if (optionValue !== true) {
			updatedCookie += "=" + optionValue;
		}
	}

	document.cookie = updatedCookie;
}

// Пример использования:
//setCookie('user', 'John', {secure: true, 'max-age': 3600});

function deleteCookie(name) {
	setCookie(name, "", {
		'max-age': -1
	})
}

//-----------------------------------------------------
// Сканирование

function StartScan() {

	$("#div-scan-tab>.bill__results.bill__results--success").removeClass("active");
	$("#div-scan-tab>.bill__results.bill__results--errors").removeClass("active");
	$("#btn-scan-close").show();

	// Остановка сканирования при покидании страницы

	window.onbeforeunload = function () {

		StopScan();
		return false;
	}

	html5QrCode = new Html5Qrcode("qr-reader");

	html5QrCode.start(
		cameraId,
		{
			fps: 10,
			qrbox: 176
		},
		qrCodeMessage => {
			// do something when code is read. For example:
			console.log('QR Code detected: ${qrCodeMessage}');

			if (qrCodeMessage.length > 0)
				onScanSuccess(qrCodeMessage);
		},
		errorMessage => {
			// parse error, ideally ignore it. For example:
			console.log('QR Code no longer in front of camera.');
		}
	)
		.catch(err => {
			// Start failed, handle it. For example,
			console.log(`Unable to start scanning, error: ${err}`);
		});
}

//-----------------------------------------------------
// Обработка результата сканирования

function onScanSuccess(qrCodeMessage) {

	console.log("onScanSuccess: " + qrCodeMessage);

	// Сохранение ID камеры

	if (cameraId != "") {

		setCookie('cameraId', cameraId); //, {secure: true, 'max-age': 24 * 3600});
	}

	StopScan(1);
	/*
		html5QrCode.stop().then(ignore => {
			// QR Code scanning is stopped.
			console.log("QR Code scanning stopped.");
		}).catch(err => {
			// Stop failed, handle it.
			console.log("Unable to stop scanning.");
		});

		$("#btn-scan-close").hide();
	*/



	//-----------------------------------------
	// Проверка сканированного кода

	$("#div-scan .bill__loader").addClass("active");

	$.ajax({
		url: "/ajax.php?mid=9",
		type: "POST",
		data: "action=save&text=" + encodeURIComponent(qrCodeMessage),
		dataType: "json",
		success: function (res) {
			console.log(res);

			$("#div-scan .bill__loader").removeClass("active");

			if (res.status != undefined) {
				if (res.status == 1)
					$("#div-scan-tab>.bill__results.bill__results--success").addClass("active");
				else {
					if ((res.error != undefined) && (res.error.length > 0))
						$("#div-scan-tab>.bill__results.bill__results--errors h4").html(res.error);
					else
						$("#div-scan-tab>.bill__results.bill__results--errors h4").html("Что-то пошло не так!");
					$("#div-scan-tab>.bill__results.bill__results--errors").addClass("active");
				}
			} else {
				$("#div-scan-tab>.bill__results.bill__results--errors").addClass("active");
			}

		},
		fail: function (e) {
			console.log(e);
			$("#div-scan .bill__loader").removeClass("active");
			$("#div-scan-tab>.bill__results.bill__results--errors").addClass("active");
		},
	});

}

//------------------------------------------------------------

$(function () {
	'use strict';

	//-----------------------------------
	// Сканирование

	$("#btn-scan").click(function () {

		$("#div-scan-wellcome .bill__results.bill__results--errors").removeClass("active");

		//-----------------------------------
		// Инициализация списка камер

		Html5Qrcode.getCameras().then(devices => {
			// devices would be an array of objects of type:
			// { id: "id", label: "label" }
			if (devices && devices.length) {

				var cookieCameraId = getCookie("cameraId");
				cameraId = "";
				cameraIndex = 0;

				for (var i = 0; i < devices.length; i++) {
					const camera = devices[i];
					const value = devices[i].id;
					const name = devices[i].label == null ? value : devices[i].label;

					camerasList[i] = devices[i];

					//	sTest += i + ". " + name + "<br>";

					console.log(i + ". " + value + " : " + name);

					// Если был сохранен ID камеры

					if ((cookieCameraId != undefined) && (cookieCameraId == value)) {
						cameraId = value;
						cameraIndex = i;
					}

				}

				// Если не найден ID камеры или не был сохранен

				if (cameraId == "") {
					cameraId = devices[0].id;
					cameraIndex = 0;
				}

				//$("#qr-reader-info").html(cameraId);

				console.log("cameraId: " + cameraId);
				console.log(devices);


				//sTest = "All: " + camerasList.length + " sel: " + cameraIndex + "<br>" + sTest;
			} else {

				//		sTest = "no camera";
			}

			if (camerasList.length > 1) {
				// Есть несколько камер
				$("#btn-select").show();

			} else if (camerasList.length == 1) {
				// Только одна камера или нет камер
				$("#btn-select").hide();

			} else {
				// Нет камер

			}

			// Начало сканирования

			StartScan();

		}).catch(err => {
			// handle err
			console.log("getCameras ERROR");

			$("#div-scan-wellcome .bill__results.bill__results--errors").addClass("active");

			$("#div-scan").hide();
			$("#div-scan-wellcome").fadeIn();

			return;

		});

		//-----------------------------------

		$(".bill__tab-content--scan").hide()
		$("#div-scan").fadeIn();

	});

	//-----------------------------------
	// Выбор камеры

	$("#btn-select").click(function () {

		if (camerasList && camerasList.length) {

			if (cameraIndex < (camerasList.length - 1)) {
				// Не последняя камера в списке

				cameraIndex++;
				cameraId = camerasList[cameraIndex].id;
			} else {
				// Последняя камера в списке

				cameraIndex = 0;
				cameraId = camerasList[cameraIndex].id;
			}

			console.log("cameraId - " + cameraId);

			html5QrCode.stop().then(ignore => {
				// QR Code scanning is stopped.
				console.log("QR Code scanning stopped.");

				html5QrCode = new Html5Qrcode("qr-reader");

				html5QrCode.start(
					cameraId,
					{
						fps: 10,
						qrbox: 176
					},
					qrCodeMessage => {
						// do something when code is read. For example:
						console.log(`QR Code detected: ${qrCodeMessage}`);

						if (qrCodeMessage.length > 0)
							onScanSuccess(qrCodeMessage);
					},
					errorMessage => {
						// parse error, ideally ignore it. For example:
						console.log(`QR Code no longer in front of camera.`);
					}
				)
					.catch(err => {
						// Start failed, handle it. For example,
						console.log(`Unable to start scanning, error: ${err}`);
					});

			}).catch(err => {
				// Stop failed, handle it.
				console.log("Unable to stop scanning.");
			});
		}
	});

	//-----------------------------------
	// Закрытие окна сканирования

	$("#btn-scan-close").click(function () {

		StopScan();

		/*
				html5QrCode.stop().then(ignore => {
					// QR Code scanning is stopped.
					console.log("QR Code scanning stopped.");
				}).catch(err => {
					// Stop failed, handle it.
					console.log("Unable to stop scanning.");
				});

				$("#div-scan").hide();
				$(".bill__tab-content--scan").fadeIn();
				*/
	});

	//--------------------------------------
	// Повторное сканирование

	$("#div-scan-tab .bill__results-restart").click(function () {

		$("#div-scan").show();
		StartScan();
	});

	//--------------------------------------
	$('form[name="frm-man"]').on("submit", function (event) {
		event.preventDefault();

		$(".bill__hand-content .form__mistakes").removeClass("active");

		$.ajax({
			url: "/ajax.php?mid=9",
			type: 'post',
			method: 'post',
			dataType: "JSON",
			data: new FormData(this),
			processData: false,
			contentType: false,
			success: function (res, status) {

				if (res.status != undefined) {
					if (res.status == 1) {
						$(".bill__hand-content .form__main").hide();

						$(".bill__hand-content .bill__results.bill__results--success").addClass("active");
					} else {

						$(".bill__hand-content .bill__results.bill__results--errors .text-block p").html(res.error);
						$(".bill__hand-content .bill__results.bill__results--errors").addClass("active");
						$(".bill__hand-content .form__main").hide();
					}
				} else {
					$(".bill__hand-content .bill__results.bill__results--errors .text-block p").html("При сохранении данных возникла ошибка!<br>Попробуйте повторить попытку.");
					$(".bill__hand-content .bill__results.bill__results--errors").addClass("active");
					$(".bill__hand-content .form__main").hide();
				}
			},
			error: function (xhr, desc, err) {
				$(".bill__hand-content .bill__results.bill__results--errors .text-block p").html("При сохранении данных возникла ошибка.<br>Попробуйте повторить попытку.");
				$(".bill__hand-content .bill__results.bill__results--errors").addClass("active");
				$(".bill__hand-content .form__main").hide();
			}
		});
	});

	//--------------------------------------
	// Повторная ручная загрузка

	$(".bill__hand .bill__results-restart").click(function () {


		$(".bill__hand-content .form__mistakes").removeClass("active");
		$(".bill__hand-content .bill__results.bill__results--errors").removeClass("active");
		$(".bill__hand-content .bill__results.bill__results--success").removeClass("active");

		$("#man-date").val("");
		$("#man-time").val("");
		$("#man-summa").val("");
		$("#man-fn").val("");
		$("#man-fd").val("");
		$("#man-fpd").val("");

		$(".bill__hand-content .form__main").show();

		document.getElementById("man-date").focus();
	});

	//------------------------------------

	$('form[name="frm-file"]').on("submit", function (event) {

		event.preventDefault();

		console.log("1111");

		$("#div-file").fadeIn();
		$("#div-file .bill__loader").addClass("active");
		$(".bill__tab-content--upload .bill__tab-caption").hide();
		$(".bill__tab-content--upload .bill__tab-action.bill__upload").hide();

		$.ajax({
			url: "/ajax.php?mid=9",
			type: 'post',
			method: 'post',
			dataType: "JSON",
			data: new FormData(this),
			processData: false,
			contentType: false,
			success: function (res, status) {

				$("#div-file .bill__loader").removeClass("active");

				if (res.status != undefined) {
					if (res.status == 1) {
						$("#div-file-tab .bill__results.bill__results--success").addClass("active");
					} else {
						$("#div-file .bill__loader").removeClass("active");
						$("#div-file-tab .bill__results.bill__results--errors").addClass("active");


						if (res.error != '') {

							$("#div-file-tab .bill__results-text--errors .text-block p").html(res.error);
						}
					}
				} else {
					$("#div-file .bill__loader").removeClass("active");
					$("#div-file-tab .bill__results.bill__results--errors").addClass("active");
				}
			},
			error: function (xhr, desc, err) {
				$("#div-file .bill__loader").removeClass("active");

				$("#div-file .bill__loader").removeClass("active");
				$("#div-file .bill__results.bill__results--errors").addClass("active");
			}
		});
	});

	//---------------------------------------------

	$('#bill-file').change(function () {

		$('form[name="frm-file"]').submit();

	});

	//--------------------------------------
	// Повторная ручная загрузка

	$("#div-file-tab .bill__results-restart").click(function () {


		$("#div-file-tab .bill__results.bill__results--errors").removeClass("active");
		$("#div-file-tab .bill__results.bill__results--success").removeClass("active");

		$("#div-file").hide();

		//$(".bill__tab-content--upload").show();
		$(".bill__tab-content--upload .bill__tab-caption").show();
		$(".bill__tab-content--upload .bill__tab-action.bill__upload").show();

	});

	//---------------------------------------------

});

// Form format date
/* $.fn.formatDate = function(){
	return this.each(function(){
		$(this).bind('keyup', function(){
			let num = this.value.replace( /\D/g, '' ).split( /(?=.)/ ),
				i = num.length;
			if ( 3 <= i ) num.splice( 2, 0, '.' );
			if ( 5 <= i ) num.splice( 5, 0, '.' );
			this.value = num.join( '' );
		});
	});
}; */
// Check date
$.fn.isValidDate = function () {
	return $(this).bind('input', function () {
		let v = $(this).val();

		const parts = v.split('.').map((p) => parseInt(p, 10));
		parts[1] -= 1;
		const d = new Date(parts[2], parts[1], parts[0]);

		if (!((d.getDate() === parts[0] && d.getMonth() === parts[1] && d.getFullYear() === parts[2]) && /^\d\d\.\d\d\.\d\d\d\d$/.test(v))) {
			this.setCustomValidity('Неверная дата!');
			console.log(this.checkValidity());
		} else {
			this.setCustomValidity('');
			console.log(this.checkValidity());
		}
	});
}
// Form format time
$.fn.formatTime = function () {
	return this.each(function () {
		$(this).bind('keyup', function () {
			let num = this.value.replace(/\D/g, '').split(/(?=.)/),
				i = num.length;
			if (3 <= i) num.splice(2, 0, ':');
			this.value = num.join('');
		});
	});
};
// Form format short tel
$.fn.formatShortPhoneNumber = function () {
	return this.each(function () {
		//console.log(this)
		//console.log($(this))
		$(this).bind('keyup', function () {
			console.log($(this).length)
			var num = this.value.replace(/\D/g, '').split(/(?=.)/), i = num.length;
			console.log(this.value)
			console.log(i)
			if (2 < i) num.splice(0, 0, '(');
			if (4 <= i) num.splice(4, 0, ')');
			if (7 <= i) num.splice(8, 0, '-');
			if (9 <= i) num.splice(11, 0, '-');
			this.value = num.join('');
		});
	});
};
// Form format tel
$.fn.formatPhoneNumber = function () {
	return this.each(function () {
		$(this).bind('keyup', function () {
			var num = this.value.replace(/^(8|7|\+7)/, '').replace(/\D/g, '').split(/(?=.)/), i = num.length;
			if (0 <= i) num.unshift('+7');
			if (1 <= i) num.splice(1, 0, '(');
			if (4 <= i) num.splice(5, 0, ')');
			if (7 <= i) num.splice(9, 0, '-');
			if (9 <= i) num.splice(12, 0, '-');
			if (11 <= i) num.splice(15, num.length - 15);
			this.value = num.join('');
		});
	});
};

//$('input[placeholder="ДД.ММ.ГГГГ"]').not('#birthday').isValidDate();
$('input[placeholder="ЧЧ:ММ"]').formatTime();
$('input[placeholder="+7 (___) ___-__-__"]').formatPhoneNumber();

//$('input[placeholder="(___) ___-__-__"]').formatShortPhoneNumber();

$('[placeholder="(___) ___-__-__"]').each(function () {
	$(this).on('click', () => {
		$(this).formatShortPhoneNumber();
	})
})
//маска для даты
$('input[placeholder="ДД.ММ.ГГГГ"]').mask("99.99.9999");
//курсор в маске на начало
$.fn.setCursorPosition = function (pos) {
	if ($(this).get(0).setSelectionRange) {
		$(this).get(0).setSelectionRange(pos, pos);
	}
	else if ($(this).get(0).createTextRange) {
		let range = $(this).get(0).createTextRange();
		range.collapse(true);
		range.moveEnd('character', pos);
		range.moveStart('character', pos);
		range.select();
	}
};
$('input[placeholder="ДД.ММ.ГГГГ"]').not('#birthday').on('click', function () {
	$(this).setCursorPosition(0);
});


// Cookie
if ($('.cookie').length) {
	var myProj = myProj || {}
	myProj.cookiePolicy = function (__M) {
		var cookiePolicy = document.querySelector('.cookie'),
			acceptCookieBtn = cookiePolicy.querySelector('.cookie__main-button');

		acceptCookieBtn.addEventListener('click', function () {
			acceptCookie();
		});

		if (document.cookie.indexOf('cookie_notice_accepted') === -1) {
			cookiePolicy.classList.add('active');
		}

		function acceptCookie() {
			if (document.cookie.indexOf('cookie_notice_accepted') === -1) {
				cookiePolicy.classList.add('active');
				// set cookie
				var d = new Date();
				d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
				document.cookie = 'cookie_notice_accepted=true' + ';expires=' + d.toGMTString();
			}

			if (cookiePolicy) {
				cookiePolicy.classList.remove('active');
				setTimeout(function () {
					cookiePolicy.parentNode.removeChild(cookiePolicy);
					cookiePolicy = null;
				}, 400);
			}
		}
	}(myProj);
}


// FAQ
$(".faq__item-question").click(function () {
	$(".faq__item-question").not(this).siblings(".faq__item-answer").slideUp();
	$(".faq__item-question").not(this).parent(".faq__item").removeClass("active");
	$(this).parent(".faq__item").toggleClass("active");
	$(this).siblings(".faq__item-answer").slideToggle();
});


// SNOW
// var snowFlakesQuantity = 40;
// var snowflakes;

// function countSnowFlakes() {
// 	if (window.matchMedia("(min-width: 320px)").matches && window.matchMedia("(max-width: 767px)").matches) {
// 		snowFlakesQuantity = 40;
// 	} else if (window.matchMedia("(min-width: 768px)").matches && window.matchMedia("(max-width: 1023px)").matches) {
// 		snowFlakesQuantity = 48;
// 	} else if (window.matchMedia("(min-width: 1024px)").matches && window.matchMedia("(max-width: 1279px)").matches) {
// 		snowFlakesQuantity = 56;
// 	} else if (window.matchMedia("(min-width: 1280px)").matches && window.matchMedia("(max-width: 1439px)").matches) {
// 		snowFlakesQuantity = 64;
// 	} else if (window.matchMedia("(min-width: 1440px)").matches && window.matchMedia("(max-width: 1679px)").matches) {
// 		snowFlakesQuantity = 72;
// 	} else if (window.matchMedia("(min-width: 1680px)").matches && window.matchMedia("(max-width: 1919px)").matches) {
// 		snowFlakesQuantity = 80;
// 	} else if (window.matchMedia("(min-width: 1920px)").matches) {
// 		snowFlakesQuantity = 88;
// 	}
// };

// function renderSnow() {
// 	countSnowFlakes();

// 	snowflakes = new Snowflakes({
// 		color: '#64D3FF',
// 		count: snowFlakesQuantity,
// 		minSize: 4,
// 		maxSize: 12,
// 		zIndex: 9,
// 	});
// };
// renderSnow();

// function reRenderSnow() {
// 	countSnowFlakes();

// 	snowflakes.count = snowFlakesQuantity;

// 	snowflakes.destroy();
// 	snowflakes = new Snowflakes({
// 		color: '#64D3FF',
// 		count: snowFlakesQuantity,
// 		minSize: 4,
// 		maxSize: 12,
// 		zIndex: 9,
// 	});
// };
